import styled from '@emotion/styled';

export const Separator = styled('div', { label: 'Separator' })`
    height: 1px;
    background-color: #cfcfcf;
    margin: 10px 0;
`;

export const AuditAllButton = styled('a', { label: 'AuditAllButton' })`
    border-radius: 3px;
    border: 1px solid #ccc;
    background: transparent;
    color: #888;
    margin: 15px;
    padding: 5px 10px;
    font-weight: bold;
    float: right;
    cursor: pointer;
    text-decoration: none;

    &:hover {
        color: #888;
    }

`;
